import { createContext, useState, useEffect } from "react";

export const AppDataContext = createContext(null);

export const AppDataProvider = ({ children }) => {
  const [appData, setAppData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAppData = async () => {
      try {
        const res = await fetch("https://portfolio-roi-back.vercel.app/api/admin/app-data");
        if (!res.ok) throw new Error(`Request failed with status ${res.status}`);
        setAppData(await res.json());
      } catch (err) {
        if (import.meta.env.DEV) {
          console.error("API Error:", err);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchAppData();
  }, []);

  return (
    <AppDataContext.Provider value={{ appData, loading }}>
      {children}
    </AppDataContext.Provider>
  );
};
